import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SiteConatctInfoState } from 'src/types/SiteConatctInfo';

const initialState: SiteConatctInfoState = {
  siteInformation: null,
  sitePersonnel: null,
  siteInformationExpanded: true,
  sitePersonnelExpanded: false,
  isBackButtonEnable: false
};

export const siteConatctInfo = createSlice({
  name: 'siteConatctInfo',
  initialState,
  reducers: {
    toggleSiteInformation: state => {
      state.siteInformationExpanded = !state.siteInformationExpanded;
      state.sitePersonnelExpanded = false;
    },
    toggleSitePersonnel: state => {
      state.sitePersonnelExpanded = !state.sitePersonnelExpanded;
      state.siteInformationExpanded = false;
    },
    setIsBackButtonEnable: (state, action: PayloadAction<any>) => {
      state.isBackButtonEnable = action.payload;
    }
  }
});

export const { toggleSitePersonnel, toggleSiteInformation, setIsBackButtonEnable } = siteConatctInfo.actions;
